import { Portal } from './apiClient'
import { acquireAccessToken } from './authProvider';
import AdHoc from './pages/AdHoc';

const portalApi = new Portal();
export const makeCancelable = (promise) => {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            val => hasCanceled_ ? reject({ isCanceled: true }) : resolve(val),
            error => hasCanceled_ ? reject({ isCanceled: true }) : reject(error)
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
};

export const getAreas = async () => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/getAreas', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getAreas")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getAreas", error)
                    reject()
                });
        })
    });
}

export const getAreaContent = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/' + areaId + '/getcontent', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getAreaContent")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getAreaContent", error)
                    reject()
                });
        })
    });
}

export const getDownloadInfo = async (areaId, files) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/download/' + areaId + '/link', token, files)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in downloadFiles")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in downloadFiles", error)
                    reject()
                });
        })
    });
}

export const uploadFiles = async (areaId, filesToUpload, onuploadProgress) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            var data = new FormData();
            for (var i = 0; i < filesToUpload.length; i++) {
                data.append("data", filesToUpload[i]);
            }
            portalApi.UPLOAD('/upload/' + areaId, token, data, onuploadProgress)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in uploadFiles")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in uploadFiles", error)
                    reject()
                });
        });
    });
}

export const getAreaSettings = async () => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/areaSettings', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getAreaSettings")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getAreaSettings", error)
                    reject()
                });
        })
    });
}

export const createArea = async (area) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/main/areas/', token, area)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    }
                    else if (response.status === 403) {
                        resolve({ isError: true, data: response.data })
                    }
                    else {
                        console.error("There was an error in createArea")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in createArea", error)
                    reject()
                });
        });
    });
}

export const searchUser = async (searchText) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/main/search/', token, searchText)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in searchUser")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in searchUser", error)
                    reject()
                });
        });
    });
}

export const getAreaUsers = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/areas/' + areaId + '/users', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getAreaUsers")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getAreaUsers", error)
                    reject()
                });
        })
    });
}

export const updateAreaUsers = async (areaId, areaUsers) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/main/areas/' + areaId + '/users', token, areaUsers)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in updateAreaUsers")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in updateAreaUsers", error)
                    reject()
                });
        });
    });
}

export const createUser = async (areaId, user) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/main/areas/' + areaId + '/newUser', token, user)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in createUser")
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in createUser", error)
                    reject()
                });
        });
    });
}

export const deleteFiles = async (areaId, files) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/main/areas/' + areaId + '/deleteFiles', token, files)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in deleteFiles")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in deleteFiles", error)
                    reject()
                });
        })
    });
}

export const renewArea = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PATCH('/main/areas/' + areaId + '/renew', token, null)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in renewArea", error)
                    reject()
                });
        })
    });
}

export const getAreaLogs = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/areas/' + areaId + '/logs', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getAreaLogs")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getAreaLogs", error)
                    reject()
                });
        })
    });
}

export const updateWriteAccess = async (areaId, user) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PATCH('/main/areas/' + areaId + '/updateWriteAccess', token, user)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in updateWriteAccess", error)
                    reject()
                });
        })
    });
}

export const loadPrivacyPolicy = async () => {
    return new Promise((resolve, reject) => {
        portalApi.GET('/main/privacyPolicy', null)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in loadPrivacyPolicy")    
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in loadPrivacyPolicy", error)
                reject()
            });
    });
}

export const acceptPrivacyPolicy = async (areaId, permissionId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PATCH('/main/areas/' + areaId + '/' + permissionId + '/acceptPrivacyPolicy', token, null)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in acceptPrivacyPolicy", error)
                    reject()
                });
        })
    });
}

export const deleteArea = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.DELETE('/main/areas/' + areaId, token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in deleteArea", error)
                    reject()
                });
        })
    });
}

export const getUpgradeAreaSettings = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/areas/' + areaId + '/upgradeSettings', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getUpgradeAreaSettings")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getUpgradeAreaSettings", error)
                    reject()
                });
        })
    });
}

export const upgradeArea = async (areaId, settingId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PATCH('/main/areas/' + areaId + '/upgrade/' + settingId, token, null)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in upgradeArea", error)
                    reject()
                });
        })
    });
}

export const releaseArea = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PUT('/main/areas/' + areaId + '/release', token, null)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in releaseArea", error)
                    reject()
                });
        })
    });
}

export const checkAccess = async () => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/main/checkAccess', token, null)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in checkAccess", error)
                    reject()
                });
        })
    });
}

export const updateAreaName = async (areaId, newName) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PATCH('/main/areas/' + areaId + '/updateName', token, { name: newName })
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in updateAreaName", error)
                    reject()
                });
        })
    });
}

export const updateAreaDescription = async (areaId, newDescription) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PATCH('/main/areas/' + areaId + '/updateDescription', token, { description: newDescription })
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        reject(response.data)
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in updateAreaDescription", error)
                    reject()
                });
        })
    });
}

export const generateAdHocLink = async (areaId, emailAddress) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PUT('/adhoc/areas/' + areaId + '/generateLink', token, { emailAddress: emailAddress })
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in generateAdHocLink")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in generateAdHocLink", error)
                reject()
            });
        })
    });
}


export const sendAdHocUserMail = async (adHocId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PUT('/adhoc/' + adHocId + '/sendUserMail', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in sendAdHocUserMail")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in sendAdHocUserMail", error)
                    reject()
                });
        })
    });
}

export const getAdHocEntry = async (adHocId) => {
    return new Promise((resolve, reject) => {
        portalApi.GET('/adhoc/' + adHocId, null, null)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve({ isError: false, data: response.data })
                }
                else if (response.status === 400) {
                    resolve({ isError: true, data: response.data })
                } else {
                    console.error("There was an error in getAdHocEntry")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in getAdHocEntry", error)
                reject()
            });
    });
}

export const sendAdHocVerificationMail = async (adHocId) => {
    return new Promise((resolve, reject) => {
        portalApi.PUT('/adhoc/sendVerificationMail', null, { adHocId: adHocId })
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in sendAdHocVerificationMail")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in sendAdHocVerificationMail", error)
                reject()
            });
    });
}

export const checkAdHocVerificationCode = async (adHocId, verificationCode) => {
    return new Promise((resolve, reject) => {
        portalApi.PUT('/adhoc/checkVerificationCode', null, { adHocId, verificationCode })
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve({ isError: false, data: response.data })
                }
                else if (response.status === 400) {
                    resolve({ isError: true, data: response.data })
                } else {
                    console.error("There was an error in checkAdHocVerificationCode")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in checkAdHocVerificationCode", error)
                reject()
            });
    });
}

export const acceptAdHocPrivacyPolicy = async (adHocId, token) => {
    return new Promise((resolve, reject) => {
        portalApi.PUT('/adhoc/' +  adHocId + '/acceptPrivacyPolicy', token)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in acceptAdHocPrivacyPolicy")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in acceptAdHocPrivacyPolicy", error)
                reject()
            });
    });
}

export const getAdHocAreaContent = async (token) => {
    return new Promise((resolve, reject) => {
        portalApi.GET('/adhoc/getContent', token)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in getAdHocAreaContent")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in getAdHocAreaContent", error)
                reject()
            });
    });
}

export const getAdHocDownloadInfo = async (files, token) => {
    return new Promise((resolve, reject) => {
        portalApi.POST('/download/adhoclink', token, files)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in getAdHocDownloadInfo")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in getAdHocDownloadInfo", error)
                reject()
            });
    });
}

export const getAdHocUsersForArea = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.GET('/adhoc/areas/' + areaId + '/users', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in getAdHocUsersForArea")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in getAdHocUsersForArea", error)
                    reject()
                });
        })
    });
}

export const addAdHocAreaUser = async (areaId, areaUser) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/adhoc/areas/' + areaId + '/user', token, areaUser)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in addAdHocAreaUser")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in addAdHocAreaUser", error)
                    reject()
                });
        });
    });
}

export const addAdHocAreaUsers = async (areaId, usersToAdd) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/adhoc/areas/' + areaId + '/users', token, usersToAdd)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in addAdHocAreaUsers")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in addAdHocAreaUsers", error)
                    reject()
                });
        });
    });
}

export const removeAdHocAreaUser = async (areaId, areaUser) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.DELETE('/adhoc/areas/' + areaId + '/users/' + areaUser.email, token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in removeAdHocAreaUser")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in removeAdHocAreaUser", error)
                    reject()
                });
        });
    });
}

export const sendAdHocUserMailAll = async (areaId) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.PUT('/adhoc/areas/' + areaId + '/sendMails/', token)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in sendAdHocUserMailAll")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in sendAdHocUserMailAll", error)
                    reject()
                });
        });
    });
}

export const uploadFilesAdHoc = async (token, filesToUpload, onuploadProgress) => {
    return new Promise((resolve, reject) => {
        var data = new FormData();
        for (var i = 0; i < filesToUpload.length; i++) {
            data.append("data", filesToUpload[i]);
        }
        portalApi.UPLOAD('/upload/adhoc', token, data, onuploadProgress)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    resolve(response.data)
                } else {
                    console.error("There was an error in uploadFilesAdHoc")
                    reject()
                }
            })
            .catch(function (error) {
                console.error("There was an error in uploadFilesAdHoc", error)
                reject()
            });
    });
}

export const checkUserExistance = async (areaId, users) => {
    return new Promise((resolve, reject) => {
        acquireAccessToken().then(token => {
            portalApi.POST('/main/areas/' + areaId + '/checkUsers', token, users)
                .then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        resolve(response.data)
                    } else {
                        console.error("There was an error in checkUserExistance")
                        reject()
                    }
                })
                .catch(function (error) {
                    console.error("There was an error in checkUserExistance", error)
                    reject()
                });
        });
    });
}